import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { ResultError } from './result-error';

export class MaxWinPerUser extends ResultError {
    constructor(pickId: string, allowedComboWin: number | undefined, possibleComboWin: number | undefined) {
        super(pickId);
        this.allowedWin = allowedComboWin == null ? null : allowedComboWin;
        this.possibleWin = possibleComboWin == null ? null : possibleComboWin;
        this.icon = BetPlacementErrorIcon.Warning;
        this.type = PlacementErrorType.MaxWinPerUserExceeded;
    }

    allowedWin: number | null;
    possibleWin: number | null;
}
